import visionLogo from "../assets/logo/visionlogo.png";
import heroVideo from "../assets/videos/vision26-bg.mp4";

export default function Hero() {


  return (
    <section className="relative min-h-screen flex items-center justify-center text-white overflow-hidden -mt-24">

      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src={heroVideo} type="video/mp4" />
      </video>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60" />

      {/* Content */}
      <div className="relative text-center max-w-5xl mx-auto px-6 flex flex-col items-center">

        {/* Vision Logo */}
        <img
          src={visionLogo}
          alt="VISION 2026"
          className="w-[420px] md:w-[560px] lg:w-[640px] object-contain"
        />

        {/* About Vision */}
        <p className="mt-8 text-lg md:text-xl text-white/85 leading-relaxed max-w-3xl">
          VISION is the flagship technical symposium of the Department of
          Electronics and Communication Engineering at the College of
          Engineering, Guindy. It brings together students, innovators,
          and engineers through technical events, workshops, and
          competitions designed to inspire creativity and practical learning.
        </p>

      </div>

    </section>
  );
}
